import { rgba } from 'polished'
import styled from 'styled-components'

import { Container as DataTableContainer } from '@presentation/components/organisms/Table/styles'

export const ResultsHeader = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 1rem;
  margin: 1rem 0 1.25rem;

  @media (max-width: 768px) {
    justify-content: flex-start;
  }
`

export const InlineLoading = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: ${props => rgba(props.theme.colors.textPrimary, 0.8)};
  font-size: 0.95rem;
`

export const Grid = styled.div`
  display: grid;
  gap: 1rem;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));

  @media (max-width: 768px) {
    grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
  }

  @media (max-width: 480px) {
    grid-template-columns: 1fr 1fr;
    gap: 0.75rem;
  }
`

export const LoadingState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  min-height: 280px;
  border: 1px solid ${props => rgba(props.theme.colors.textPrimary, 0.1)};
  border-radius: 0.75rem;
  background-color: ${props => props.theme.colors.backgroundContent};
  color: ${props => props.theme.colors.textPrimary};
`

export const EmptyState = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 220px;
  margin-top: 1rem;
  padding: 2rem;
  border: 1px dashed ${props => rgba(props.theme.colors.textPrimary, 0.25)};
  border-radius: 0.75rem;
  background-color: ${props => rgba(props.theme.colors.backgroundContent, 0.5)};
  color: ${props => props.theme.colors.textPrimary};
  text-align: center;
`

export const StateWrapper = styled.div`
  margin-top: 1rem;
`

export const RetryButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  margin-top: 0.75rem;
  padding: 0.55rem 0.9rem;
  border: 0;
  border-radius: 0.4rem;
  background-color: ${props => props.theme.colors.primary};
  color: ${props => props.theme.colors.white};

  &:focus-visible {
    outline: 3px solid ${props => rgba(props.theme.colors.primary, 0.35)};
    outline-offset: 2px;
  }
`

export const PaginationDataTableWrapper = styled(DataTableContainer)`
  margin-top: 1.5rem;

  .rdt_ResponsiveWrapper {
    min-height: 0;
    border: 0;
    overflow: visible;
  }

  .rdt_Table {
    display: none;
  }

  .rdt_Pagination {
    border-top: 0;
  }
`

export const PaginationWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 1rem;
  margin-top: 1.5rem;
  min-height: 56px;
  padding: 0 0.5rem;
  font-size: 13px;
  color: ${props => rgba(props.theme.colors.textPrimary, 0.8)};

  .pagination {
    margin-bottom: 0;
    flex-wrap: nowrap;
    align-items: center;
    gap: 0;
  }

  .page-link {
    min-width: 2.5rem;
    height: 2.5rem;
    padding: 0.5rem;
    border: 0;
    border-radius: 999px;
    background-color: transparent;
    color: ${props => rgba(props.theme.colors.textPrimary, 0.72)};
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 13px;
    box-shadow: none;
  }

  .page-link:hover {
    background-color: ${props => rgba(props.theme.colors.textPrimary, 0.06)};
    color: ${props => props.theme.colors.textPrimary};
  }

  .page-item.active .page-link {
    background-color: ${props => rgba(props.theme.colors.primary, 0.12)};
    color: ${props => props.theme.colors.primary};
    font-weight: 600;
  }

  .page-item.disabled .page-link {
    background-color: transparent;
    color: ${props => rgba(props.theme.colors.textPrimary, 0.32)};
    opacity: 1;
  }

  .page-item:not(.active):not(.disabled) .page-link:focus,
  .page-item:not(.active):not(.disabled) .page-link:active {
    background-color: ${props => rgba(props.theme.colors.textPrimary, 0.08)};
    color: ${props => props.theme.colors.textPrimary};
    box-shadow: none;
  }

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
    padding: 0;

    .pagination {
      flex-wrap: wrap;
      justify-content: center;
    }
  }
`

export const PerPageControl = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: ${props => rgba(props.theme.colors.textPrimary, 0.8)};

  select {
    width: auto;
    min-width: 4.5rem;
    max-width: 4.5rem;
    padding: 0 1.5rem 0 0.35rem;
    border: 0;
    border-radius: 0;
    background-color: transparent;
    box-shadow: none;
    color: ${props => props.theme.colors.textPrimary};
    font-size: 13px;
  }
`

export const PerPageLabel = styled.label`
  color: ${props => rgba(props.theme.colors.textPrimary, 0.8)};
  font-size: 13px;
  white-space: nowrap;
`

export const PaginationSummary = styled.span`
  flex: 1;
  color: ${props => rgba(props.theme.colors.textPrimary, 0.8)};
  font-size: 13px;
  text-align: center;
  white-space: nowrap;

  @media (max-width: 768px) {
    text-align: center;
    order: 3;
  }
`
